import { render, staticRenderFns } from "./PortfoliosPage.vue?vue&type=template&id=54ca5c0e"
import script from "./PortfoliosPage.vue?vue&type=script&lang=ts"
export * from "./PortfoliosPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports